export default __webpack_public_path__ + "4c19a6dd8558a8e82f16d174837df176.svg";